import { IANAZone } from "luxon";
import { SharedApiV2 } from "@capstone/mock-api";
import { PaginationV2 } from "src/app/core/pagination-v2";
import { ColumnFilter } from "src/app/core/table";
import { ColumnSort, SortOrder } from "src/utils";

export abstract class PaginatedListQuery<K extends string = string> {
  protected constructor(args: ClassProperties<PaginatedListQuery<K>>) {
    this.columnFilters = args.columnFilters;
    this.pagination = args.pagination;
    this.sort = args.sort;
    this.timezone = args.timezone;
  }

  public readonly columnFilters?: readonly ColumnFilter[];
  public readonly pagination: PaginationV2;
  public readonly sort: ColumnSort<K>;
  public readonly timezone?: IANAZone;

  public serializeBase<T extends object>(): SharedApiV2.PagedListFilters<T> {
    return {
      pageNumber: this.pagination.currentPageNumber,
      pageSize: this.pagination.pageSize,
      sortAscending: this.sort.order === SortOrder.Ascending,
      sortColumn: this.sort.key,
    };
  }
}
